import styled from "styled-components";

export const TemplateChangedModalDiv = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 16px !important;
    justify-content: center;
    overflow: hidden;
    padding: 24px 16px;
    text-align: center;

    > p {
        line-height: 1.5em;

        & + p {
            margin-top: 10px;
        }
    }
`;
